import {profilePage} from "./print/profilePage";
import {searchResults} from "./print/searchResults";

export function print() {
    profilePage();
    searchResults();
}